// extracted by mini-css-extract-plugin
export default {"backToTop":"_2rojepQtBLz2OWYkkS-sXk","chevron":"_1tAl3Pfh6HM5Lo4dx6lSIx"};